import { all } from 'redux-saga/effects'
import { watchSignIn } from './handlers/auth'
import { watchDebt } from './handlers/debt'
import { watchOrganization } from './handlers/organization'
import { watchUser } from './handlers/user'

export function* watcherSaga() {
  yield all([watchSignIn(), watchUser(), watchDebt(), watchOrganization()])
}
